import FeatureController from '../FeatureController';

export default class SwipeController extends FeatureController
{
  constructor(panel, $state) {
    super(panel, $state);
    this.endpoint = '/v1/matches/swipe';
    this.matches = [];
    this.topCardIndex=0;
    const self = this;
    panel.registerEvent('on.swipe.liked', (data) => {
      if (data.detail) {
        self.swipeLiked(data.detail);
      }
    });

    panel.registerEvent('on.swipe.disliked', (data) => {
      if (data.detail) {
        self.swipeDisliked(data.detail);
      }
    });
    this.set_instalike();
  }

  swipeLeft () {
    $('#swipe-card-number-'+this.topCardIndex).trigger('swipe.left', [{index:this.topCardIndex}]);
  }

  swipeRight () {
    $('#swipe-card-number-'+this.topCardIndex).trigger('swipe.right', [{index:this.topCardIndex}]);
  }

  swipeLiked (data) {
    this.topCardIndex = parseInt(data.index) + 1;
    console.log('I like '+ this.matches[data.index].screen_name + '. No ' + data.index);
  }

  swipeDisliked (data) {
    this.topCardIndex = parseInt(data.index) + 1;
    console.log('I don\'t like ' + data.index + '. No ' + data.index);
  }

  toggle_instalikes (hasLikes) {
      !hasLikes ? $('.has-instalikes').hide() && $('.nomore-instalkies').show() : $('.has-instalikes').show() && $('.nomore-instalkies').hide();
  }

  set_instalike (reaction, user_id) {
    const self = this;

    if(this.matches.length === 0 && !user_id) {
        self.show_next_like();

    } else {
        if(typeof reaction == 'number'){
            $('.ilike-action').prop('disabled', true);
            this.panel.post('/v1/matches/swipe', {likes:user_id,reaction:reaction}, function(response){

                if(self.panel.okay(response) && response.insta_like_mutual){
                    return self.show_next_like();
                    self.panel.get('/v1/popup?t=match-card&insta_like_mutual='+response.insta_like_mutual, function(popup){
                        self.panel.popup_init(popup, $scope);
                        self.show_next_like();
                    });
                }
                else{
                    self.show_next_like();
                }
            });
        }
    }
  }

  show_next_like () {

    if (self.loadingMatches) return;

    if (this.matches.length > 0) {
      $('.ilike-action').prop('disabled', false);
      this.panel.unload('.has-instalikes');
      this.toggle_instalikes(true);
    } else {
        const self = this;
        self.loadingMatches = true;
   //     this.panel.loading('.has-instalikes');
        this.panel.post('/v1/matches/swipe', {q:'play'}, function(response) {
          self.loadingMatches = false;
          if(self.panel.okay(response) && response.matches.length > 0) {
              if (self.matches.length === 0) {
                  self.matches = response.matches;
              } else {
                  for(let i in response.matches) {
                      self.matches.push(response.matches[i]);
                  }
              }
              if (!self.swipingStarted) {
                  self.swipingStarted = true;
                  //self.startX();
              }
              $('.ilike-action').prop('disabled', false);
              self.panel.unload('.has-instalikes');
              self.toggle_instalikes(true);
          }
          else{
              self.instalike = false;
              self.toggle_instalikes();
          }
        });
      }
  }

  startX () {
    const self = this;
    $(document).ready(function() {
      let animating = false;
      let cardsCounter = 0;
      let numOfCards = self.matches.length;
      let decisionVal = 80;
      let pullDeltaX = 0;
      let deg = 0;
      let user_id = 0;
      let $card, $cardReject, $cardLike;

      function pullChange() {
        animating = true;
        deg = pullDeltaX / 10;
        $card.css("transform", "translateX("+ pullDeltaX +"px) rotate("+ deg +"deg)");

        let opacity = pullDeltaX / 100;
        let rejectOpacity = (opacity >= 0) ? 0 : Math.abs(opacity);
        let likeOpacity = (opacity <= 0) ? 0 : opacity;
        $cardReject.css("opacity", rejectOpacity);
        $cardLike.css("opacity", likeOpacity);
      };

      function release() {

        if (pullDeltaX >= decisionVal) {
          $card.addClass("to-right");
        } else if (pullDeltaX <= -decisionVal) {
          $card.addClass("to-left");
        }

        if (Math.abs(pullDeltaX) >= decisionVal) {
          $card.addClass("inactive");

          setTimeout(function() {
            $card.addClass("below").removeClass("inactive to-left to-right");
            cardsCounter++;
            if (cardsCounter === numOfCards) {
              cardsCounter = 0;
              $(".swipe__card").removeClass("below");
            }
          }, 300);
        }

        if (Math.abs(pullDeltaX) < decisionVal) {
          $card.addClass("reset");
        } else {
          let action = pullDeltaX < 0 ? 0 : 1;
          self.set_instalike(action, user_id);
        }

        setTimeout(function() {
          $card.attr("style", "").removeClass("reset")
            .find(".swipe__card__choice").attr("style", "");

          pullDeltaX = 0;
          animating = false;
        }, 300);

      };

      $(document).on("mousedown touchstart", ".swipe__card:not(.inactive)", function(e) {
        if (animating) return;

        $card = $(this);
        user_id = $card.attr('user_id');
        $cardReject = $(".swipe__card__choice.m--reject", $card);
        $cardLike = $(".swipe__card__choice.m--like", $card);
        let startX =  e.pageX || e.originalEvent.touches[0].pageX;

        $(document).on("mousemove touchmove", function(e) {
          let x = e.pageX || e.originalEvent.touches[0].pageX;
          pullDeltaX = (x - startX);
          if (!pullDeltaX) return;
          pullChange();
        });

        $(document).on("mouseup touchend", function() {
          $(document).off("mousemove touchmove mouseup touchend");
          if (!pullDeltaX) return; // prevents from rapid click events
          release();
        });
      });

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/features/swipe/SwipeController.js